<button
  *ngIf="visible"
  [matBadge]="notificationCount > 0 ? notificationCount : null"
  matBadgeColor="accent"
  mat-icon-button
  class="floating-icon-square"
  aria-label="Notifications"
  [class.active]="isNotificationsActive"
  [class.has-unread]="notificationCount > 0"
  (click)="onFloaterClick()"
>
  <mat-icon>notifications</mat-icon>
</button>
